import { useRouter } from 'next/router';
import { FC } from 'react';

import { Icons, IconsTypes } from '@/components/shared/Icons';
import Link from '@/components/shared/Link';
import { useLocale } from '@/hooks/useLocale';

interface ILogoProps {
  isLight?: boolean;
}

export const Logo: FC<ILogoProps> = ({ isLight }) => {
  const { isEnLocale } = useLocale();

  const route = useRouter();
  const basePath = route.asPath.split(`${route.pathname}/`)[0].replace(`${route.query.locale}/`, '');

  const className = `flex-none aspect-[250/80] w-[150px] sm:w-[170px] md:w-[250px] flex-none ${
    isLight ? 'text-white' : 'text-black-600'
  }`;

  const Wrapper = ({ children }: { children: JSX.Element | null }) =>
    basePath === '/' ? (
      <div className={className}>{children}</div>
    ) : (
      <Link className={className} href="/">
        {children}
      </Link>
    );
  return (
    <Wrapper>
      <Icons name={isEnLocale ? IconsTypes.LOGO_EN : IconsTypes.LOGO} iconProps={{ className: '' }} />
    </Wrapper>
  );
};
